import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "车位传感器消息展示", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        width: "300px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "active-text-color": "#ffd04b",
          "background-color": "#545c64",
          class: "el-menu-vertical-demo",
          "text-color": "#fff",
          router: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItemList, item => {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              index: item.path,
              key: item.path
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
              _: 2
            }, 1032, ["index"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}